import React from "react";
import leftsm from "../assets/icons/leftsm.svg";
import linkedin from "../assets/icons/linkedin.svg";
import instagram from "../assets/icons/instagram.svg";
import github from "../assets/icons/github.svg"
// import { IconBrandInstagram, IconBrandLinkedin, IconMailFilled } from "@tabler/icons-react"

const Footer = () => {
  return (
    <div className="absolute left-0 w-full cursor-default" id="footer">
      <div className="bg-[#FF6812] w-full flex flex-col items-center justify-center p-5 md:p-20 rounded-t-xl">
        <h1 className="text-2xl md:text-7xl font-bold">Get In Touch With Me</h1>
        <p className="text-xs md:text-xl md:pt-4">
          Do you have any project ideas? I would love to learn More
        </p>
        <div className="flex gap-4 mt-4 md:mt-10">
          <a href="https://mail.google.com/mail/u/0/?view=cm&tf=1&fs=1&to=jindanza7@gmail.com" target="_blank" className="flex items-center bg-[#141414] rounded-full p-4 md:p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
            <img src={leftsm} alt="" className="w-4 md:w-6" />
            {/* <IconMailFilled size={30}/> */}
          </a>
          <a href="https://github.com/jindanza/" target="_blank" className="flex items-center bg-[#141414] rounded-full p-4 md:p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
            <img src={github} alt="" className="w-4 md:w-6" />
            {/* <IconMailFilled size={30}/> */}
          </a>
          <a href="https://www.linkedin.com/in/muhammad-jindan/" target="_blank" className="flex items-center bg-[#141414] rounded-full p-4 md:p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
            <img src={linkedin} alt="" className="w-4 md:w-6" />
            {/* <IconBrandLinkedin size={30}/> */}
          </a>
          <a href="https://www.instagram.com/jindanza/?hl=id" target="_blank" className="flex items-center bg-[#141414] rounded-full p-4 md:p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
            <img src={instagram} alt="" className="w-4 md:w-6" />
            {/* <IconBrandInstagram size={30}/> */}
          </a>
        </div>
      </div>
      <div className="bg-[#141414] p-3 md:p-6 flex items-center justify-center text-xs md:text-base">
        @2025 by Muhammad Jindan
      </div>
    </div>
  );
};

export default Footer;
